// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__7S3si","dashboard":"Dashboard_dashboard__Tp5NQ"};